import { Box, IconButton, Flex, useMediaQuery } from '@podiumhq/design-system';

import Imagery from 'components/Trials/components/Animations/SignUpPage';

import useTrialAccountDetails from '../../hooks/useTrialAccountDetails';
import { handleCloseTrialModal } from '../../utils';

import SignupContent from './SignupContent';

const RoiSignupPage = () => {
  const [isSmallerThan850px] = useMediaQuery('(max-width: 850px)');

  const { handleSubmit, isInPodiumIframe, isSubmitting } =
    useTrialAccountDetails();

  return (
    <Box height="100vh">
      {isInPodiumIframe && (
        <IconButton
          onClick={handleCloseTrialModal}
          type="XClose"
          size="md"
          variant="ghost"
          fillColor="silver.light"
          position="absolute"
          marginTop="32px"
          right="32px"
          zIndex="1"
          sx={{
            background: 'black.lighter',
            _hover: { background: 'black.lightest' },
          }}
        />
      )}

      <Flex>
        <SignupContent
          isSubmitting={isSubmitting}
          handleSubmit={handleSubmit}
          isMobile={isSmallerThan850px}
        />
        {!isSmallerThan850px && <Imagery />}
      </Flex>
    </Box>
  );
};

export default RoiSignupPage;
